import ResponsiveHeader from '@/components/ResponsiveHeader';
import { DrawerItem } from '@/lib/DrawerContext';
import { Stack } from 'expo-router';
import { Image, Pressable } from 'react-native';

// Type-safe extension of navigation options
declare module '@react-navigation/native' {
  export interface NativeStackNavigationOptions {
    showBookmark?: boolean;
    drawerItems?: DrawerItem[];
  }
}

// Type-safe interface for our custom screen options
interface CustomScreenOptions {
  title?: string;
  showBookmark?: boolean;
  drawerItems?: DrawerItem[];
}

// `courses/index` is the anchor of this stack, so any screen reached by push
// (a course, a lesson, the instructors browse/detail) can always back out to
// the courses catalog — and tapping Home (dismissTo '/courses') pops here.
export const unstable_settings = {
  initialRouteName: 'courses/index',
};

/**
 * The "home" stack. Both the courses catalog and the instructors section live
 * here (via the URL-less `(home)` group), so they share one navigation stack:
 * `/instructors` pushes on top of `/courses`, back works natively, and Home
 * pops the whole stack back to the catalog. New home-adjacent sections can be
 * added as sibling folders here and get the same behaviour for free.
 */
export default function HomeStackLayout() {
  return (
    <Stack
      screenOptions={{
        animation: 'default',
        header: ({ navigation, options, back }) => {
          const customOptions = options as CustomScreenOptions;
          const showBookmark = customOptions.showBookmark ?? true;

          return (
            <ResponsiveHeader
              title={customOptions.title || ''}
              showBack={!!back}
              showBookmark={showBookmark}
              onBack={() => navigation.goBack()}
              navItems={[
                { label: 'Explore', href: '/explore' },
                { label: 'Live', href: '/live' },
                { label: 'The Hang', href: '/library' },
              ]}
              right={
                <Pressable onPress={() => { /* open profile */ }} hitSlop={8}>
                  <Image
                    source={{ uri: 'https://placehold.co/32x32' }}
                    style={{ width: 28, height: 28, borderRadius: 14, backgroundColor: '#555' }}
                  />
                </Pressable>
              }
            />
          );
        },
      }}
    >
      <Stack.Screen name="courses/index" options={{ title: '' }} />
      <Stack.Screen
        name="courses/skillpath/[skill-pathway-slug]"
        options={{ title: '' }}
      />
      <Stack.Screen name="instructors/index" options={{ title: '' }} />
    </Stack>
  );
}
